module.exports = __webpack_public_path__ + "static/media/sahil_tejwani.97c473cc.png";